/* Ability homepage motion (V5.3.7). Loaded deferred from sections/ah-hero.liquid.
   - Scroll reveal: same spec as the PDP (.pdp-reveal) and values-grid: 18px rise, .55s,
     70ms stagger, threshold .12, rootMargin -8%. Elements are only hidden once this runs,
     so no-JS visitors and crawlers always get fully visible content.
   - Buttons never move with the cursor (magnetic effect removed in V5.3.6 at Bradley's request).
   - Values manifesto (V5.3.7): the value words in the sentence light up one by one as it scrolls
     up the viewport, and each value's top line draws in with its word. Scroll-linked, reversible,
     opacity/transform only; the scroll listener only runs while the section is on screen.
   Everything is skipped under prefers-reduced-motion. */
(function () {
  if (window.__ahMotion) return;
  window.__ahMotion = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  /* Groups: each entry is one staggered set. Shared sections (why, venues, faq, cta) are
     targeted by selector so their files stay untouched; this script only loads on the homepage. */
  var groups = [
    '.ah-sec .ah-head > :not(div), .ah-sec .ah-head > div > *',
    '.ah-cred__seal, .ah-cred__body > *',
    '.ah-services__grid > li',
    '.ah-cats__head > *',
    '.ah-cats__list > li',
    '.section-why-ability .wa__eyebrow, .section-why-ability .wa__title',
    '.section-why-ability .wa__proof',
    '.section-ability-venues .afc-venues__head .afc-eyebrow, .section-ability-venues .afc-venues__title, .section-ability-venues .afc-venues__intro',
    '.section-ability-venues .afc-venue',
    '.ah-about__grid > div:first-child > *',
    '.ah-about__stories > *',
    '.ah-quotes > li',
    '.ah-logos__label, .ah-logos__list > li',
    '.ah-values__grid > li',
    '.section-faq-accordion .fa__head > *',
    '.section-faq-accordion .fa__item',
    '.section-team-cta .tcta__panel'
  ];

  /* Once an element has finished revealing, drop the reveal classes so its normal
     hover transitions (lift, shadow) run without the stagger delay. */
  function done(el) {
    if (!el.classList.contains('ah-rv')) return;
    el.removeEventListener('transitionend', settle);
    el.classList.remove('ah-rv', 'ah-rv-eb', 'is-in');
    el.style.removeProperty('--rv-delay');
  }
  function settle(ev) {
    var el = ev.currentTarget;
    if (ev.target !== el) return;
    var eb = el.classList.contains('ah-rv-eb');
    if (eb ? ev.pseudoElement !== '::before' : (ev.pseudoElement || ev.propertyName !== 'opacity')) return;
    done(el);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      el.classList.add('is-in');
      io.unobserve(el);
      /* safety net in case a transitionend never fires (e.g. an eyebrow without a line) */
      setTimeout(function () { done(el); }, 1600 + (parseInt(el.style.getPropertyValue('--rv-delay'), 10) || 0));
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  groups.forEach(function (sel) {
    var parents = new Map();
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.classList.contains('ah-rv')) return;
      var p = el.parentNode;
      var i = parents.get(p) || 0;
      parents.set(p, i + 1);
      el.style.setProperty('--rv-delay', Math.min(i, 8) * 70 + 'ms');
      el.classList.add('ah-rv');
      if (/eyebrow/.test(el.className)) el.classList.add('ah-rv-eb');
      el.addEventListener('transitionend', settle);
      io.observe(el);
    });
  });

  /* Values manifesto: word n lights once the sentence's top has travelled n fifths of the way
     from 85% to 35% of the viewport height. */
  document.querySelectorAll('.ah-values').forEach(function (sec) {
    var line = sec.querySelector('.ah-manifesto');
    var words = sec.querySelectorAll('.ah-mw');
    if (!line || !words.length) return;
    var items = {};
    sec.querySelectorAll('.ah-value[data-i]').forEach(function (li) { items[li.getAttribute('data-i')] = li; });
    var lit = -1, ticking = false;
    function paint() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var p = (vh * 0.85 - line.getBoundingClientRect().top) / (vh * 0.5);
      var n = p <= 0 ? 0 : Math.min(words.length, Math.ceil(p * words.length));
      if (n === lit) return;
      lit = n;
      for (var k = 0; k < words.length; k++) {
        var on = k < n;
        words[k].classList.toggle('is-on', on);
        var li = items[words[k].getAttribute('data-i')];
        if (li) li.classList.toggle('is-on', on);
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(paint); } }
    sec.classList.add('is-live');
    paint();
    new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll, { passive: true }); onScroll(); }
      else { window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll); onScroll(); }
    }).observe(sec);
  });
})();